import React from "react";

import ViewMag from "../components/dashboard/common/ViewMag";

const ViewMagazine = () => {
  return (
    <>
      <div className="px-20">
        <ViewMag />
      </div>
    </>
  );
};

export default ViewMagazine;
